export const comments_3324442 = {"data":{"data":[],"links":{}}}